export default {
  'user-login.login.userName': '帳戶',
  'user-login.login.password': '密碼',
  'user-login.login.message-invalid-credentials': '帳戶或密碼錯誤（admin/ant.design）',
  'user-login.login.message-invalid-verification-code': '驗證碼錯誤',
  'user-login.login.tab-login-credentials': '帳戶密碼登錄',
  'user-login.login.tab-login-mobile': '手機號登錄',
  'user-login.login.remember-me': '自動登錄',
  'user-login.login.forgot-password': '忘記密碼',
  'user-login.login.sign-in-with': '其他登錄方式',
  'user-login.login.signup': '註冊帳戶',
  'user-login.login.login': '登入',
  'user-login.register.register': '註冊',
  'user-login.register.get-verification-code': '獲取驗證碼',
  'user-login.register.sign-in': '使用已有帳戶登錄',
  'user-login.register-result.msg': '妳的帳戶：{email} 註冊成功',
  'user-login.register-result.activation-email':
    '激活郵件已發送到妳的郵箱中，郵件有效期為24小時。請及時登錄郵箱，點擊郵件中的鏈接激活帳戶。',
  'user-login.register-result.back-home': '返回首頁',
  'user-login.register-result.view-mailbox': '查看郵箱',
  'user-login.email.required': '請輸入郵箱地址！',
  'user-login.email.wrong-format': '郵箱地址格式錯誤！',
  'user-login.userName.required': '請輸入帳戶!',
  'user-login.password.required': '請輸入密碼！',
  'user-login.password.twice': '兩次輸入的密碼不匹配!',
  'user-login.strength.msg': '請至少輸入 6 個字符。請不要使用容易被猜到的密碼。',
  'user-login.strength.strong': '強度：強',
  'user-login.strength.medium': '強度：中',
  'user-login.strength.short': '強度：太短',
  'user-login.confirm-password.required': '請確認密碼！',
  'user-login.phone-number.required': '請輸入手機號！',
  'user-login.phone-number.wrong-format': '手機號格式錯誤！',
  'user-login.verification-code.required': '請輸入驗證碼！',
  'user-login.title.required': '請輸入標題',
  'user-login.date.required': '請選擇起止日期',
  'user-login.goal.required': '請輸入目標描述',
  'user-login.standard.required': '請輸入衡量標淮',
  'user-login.form.get-captcha': '獲取驗證碼',
  'user-login.captcha.second': '秒',
  'user-login.form.optional': '（選填）',
  'user-login.form.submit': '提交',
  'user-login.form.save': '保存',
  'user-login.email.placeholder': '郵箱',
  'user-login.password.placeholder': '至少6位密碼，區分大小寫',
  'user-login.confirm-password.placeholder': '確認密碼',
  'user-login.phone-number.placeholder': '手機號',
  'user-login.verification-code.placeholder': '驗證碼',
  'user-login.title.label': '標題',
  'user-login.title.placeholder': '給目標起個名字',
  'user-login.date.label': '起止日期',
  'user-login.placeholder.start': '開始日期',
  'user-login.placeholder.end': '結束日期',
  'user-login.goal.label': '目標描述',
  'user-login.goal.placeholder': '請輸入妳的階段性工作目標',
  'user-login.standard.label': '衡量標淮',
  'user-login.standard.placeholder': '請輸入衡量標淮',
  'user-login.client.label': '客戶',
  'user-login.label.tooltip': '目標的服務對象',
  'user-login.client.placeholder': '請描述妳服務的客戶，內部客戶直接 @姓名／工號',
  'user-login.invites.label': '邀評人',
  'user-login.invites.placeholder': '請直接 @姓名／工號，最多可邀請 5 人',
  'user-login.weight.label': '權重',
  'user-login.weight.placeholder': '請輸入',
  'user-login.public.label': '目標公開',
  'user-login.label.help': '客戶、邀評人默認被分享',
  'user-login.radio.public': '公開',
  'user-login.radio.partially-public': '部分公開',
  'user-login.radio.private': '不公開',
  'user-login.publicUsers.placeholder': '公開給',
  'user-login.option.A': '同事甲',
  'user-login.option.B': '同事乙',
  'user-login.option.C': '同事丙',
  'user-login.navBar.lang': '語言',
};
